'use strict';

function branch(p, f, g, a) {
  return p(a) ? f(a) : g(a);
}

module.exports = branch;
